<template>
  <div class="col form-group">
    <div v-if="Attributes.length > 0">
      <div v-bind:key="i" v-for="(a, i) in Attributes">
        <div style="text-align: left">
          {{ a.question }}
        </div>
        <div v-if="a.type === 1" class="my-3">
          <textarea style="width: 100%" v-model="answerObj.element[i].AttributeValue" />
        </div>
        <div v-else-if="a.type === 2" class="my-3">
          <select
            style="height: 35px; margin-top: 10px"
            class="w-100 c-select"
            v-model="answerObj.element[i].AttributeValue"
          >
            <option style="color: black" value="" disabled hidden>Escolha uma opção</option>
            <option
              style="color: black"
              v-for="option in a.options"
              :value="option.value"
              :key="option.value"
            >
              {{ option.value }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-else class="text-center">{{ strings.loading }}<LoadingRing></LoadingRing></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { loginFB } from '../../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'Attribute',
  props: {
    validate: Boolean,
  },
  data: () => ({
    obj: {},
    answerObj: {
      element: [],
    },
    strings: {
      loading: 'Buscando atributos...',
    },
    Attributes: [],
  }),
  computed: {
    ...mapState(['config', 'template', 'registrationObject', 'subdomain']),
  },

  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },

  mounted() {
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    this.getAttributesService(this.config.ownerId)
  },

  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),

    async getAttributesService(ownerId) {
      await lFB
        .getAttributes(ownerId)
        .then(response => {
          this.saveResponseInAttributes(response)
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: `Erro`,
            variant: 'danger',
            solid: true,
          })
        })
    },

    filterAnswerObj() {
      this.answerObj.element = this.answerObj.element.filter(x => x.AttributeValue !== null)
    },

    fillAnswerObjArr() {
      for (let i = 0; i < this.Attributes.length; i++) {
        this.answerObj.element.push({
          AttributeKey: this.Attributes[i].key,
          AttributeValue: this.getAttributeValueByKey(this.Attributes[i].key),
        })
      }
    },

    getAttributeValueByKey(key) {
      if (this.obj.Attributes) {
        for (let i = 0; i < this.obj.Attributes.length; i++) {
          if (this.obj.Attributes[i].AttributeKey === key) {
            return this.obj.Attributes[i].AttributeValue
              ? this.obj.Attributes[i].AttributeValue
              : null
          }
        }
        return null
      } else {
        return null
      }
    },

    saveResponseInAttributes(response) {
      this.Attributes = response
      this.fillAnswerObjArr()
    },

    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false
      let objAttributes = {}

      this.filterAnswerObj()

      objAttributes.Attributes = this.answerObj.element

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', objAttributes)
        this.$emit('next')
      }
    },
  },
}
</script>
